/* how long is the interval between consequetive booking possibilities */
export const SLOT_INTERVAL_MIN = 15;
export const SLOT_INTERVAL_MS = SLOT_INTERVAL_MIN*60*1000;
export const ONE_DAY = 24*60*60*1000;
/* session length */ 
export const MAX_SESSION_LENGTH_MS = 50*60*1000;
export const SESSION_LENGTH_MS = 50*60*1000; // prolly will disappear


/* how many users to keep for one slot */
export const SLOT_USER_LIMIT = 4;
/* how many slots is covered by one slot (influences selectability) */
export const COVERED_BY_SLOT_COUNT = 3;
